import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6660c283"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "maincontainer py-8 px-4" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "AddForms")
], -1))
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = ["onBlur", "onUpdate:modelValue"]
const _hoisted_7 = {
  key: 1,
  class: "screenName"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = {
  style: {"width":"50%"},
  class: "flex justify-between"
}
const _hoisted_12 = { class: "w-1/2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "InputControls", -1))
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "TextBox", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "TextArea", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Radio", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "CheckBox", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Dropdown", -1))
const _hoisted_20 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "flex flex-col justify-center items-center mt-2 w-1/2"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Mandatory", -1))
const _hoisted_23 = { class: "switch mt-1" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_26 = {
  style: {"width":"50%"},
  class: "flex justify-between"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "label", -1))
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = {
  key: 1,
  class: "ml-3"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Option", -1))
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "imgoptioncontainer" }
const _hoisted_35 = { class: "ml-2" }
const _hoisted_36 = { class: "flex" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "flex justify-center mt-4" }
const _hoisted_41 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PencilIcon = _resolveComponent("PencilIcon")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btnprimary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addForms()))
        }, "Add Form")
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (form, formIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "card shadow-2xl p-4 mt-4",
        key: formIndex
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                (form.toggleSourceInput)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      onBlur: ($event: any) => (form.toggleSourceInput = false),
                      type: "text",
                      class: "inputboxstyling",
                      "onUpdate:modelValue": ($event: any) => ((form.formName) = $event),
                      placeholder: "FormName"
                    }, null, 40, _hoisted_6)), [
                      [_vModelText, form.formName]
                    ])
                  : _createCommentVNode("", true),
                (!form.toggleSourceInput)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_7, _toDisplayString(form.formName), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "controlicons flex p-1 mt-1.5",
                onClick: ($event: any) => (form.toggleSourceInput = true)
              }, [
                _createVNode(_component_PencilIcon, { class: "h-2.5 w-2.5" })
              ], 8, _hoisted_8)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btnprimary",
                onClick: ($event: any) => (_ctx.addInputControlsForFormData(form))
              }, "Add", 8, _hoisted_9)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.inputControls, (inputControl, inputControlIndex) => {
            return (_openBlock(), _createElementBlock("div", { key: inputControlIndex }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _withDirectives(_createElementVNode("select", {
                      class: "inputboxstyling",
                      "onUpdate:modelValue": ($event: any) => ((inputControl.screenType) = $event)
                    }, _hoisted_20, 8, _hoisted_14), [
                      [_vModelSelect, inputControl.screenType]
                    ])
                  ]),
                  (inputControl.screenType)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("label", _hoisted_23, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((inputControl.mandatory) = $event)
                          }, null, 8, _hoisted_24), [
                            [_vModelCheckbox, inputControl.mandatory]
                          ]),
                          _hoisted_25
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (inputControl.screenType)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _hoisted_28,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "inputboxstyling",
                          "onUpdate:modelValue": ($event: any) => ((inputControl.label) = $event)
                        }, null, 8, _hoisted_29), [
                          [_vModelText, inputControl.label]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (inputControl.screenType == 'Radio' || inputControl.screenType == 'CheckBox' || inputControl.screenType == 'Dropdown')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _hoisted_31,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "inputboxstyling",
                          "onUpdate:modelValue": ($event: any) => ((inputControl.option) = $event)
                        }, null, 8, _hoisted_32), [
                          [_vModelText, inputControl.option]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (inputControl.screenType == 'Radio' || inputControl.screenType == 'CheckBox' || inputControl.screenType == 'Dropdown')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "gap-1.5 mt-6 ml-3",
                        onClick: ($event: any) => (_ctx.addLabelsforInputControls(form, inputControlIndex, inputControl.option))
                      }, [
                        _createVNode(_component_PlusIcon, { class: "w-8 h-8" })
                      ], 8, _hoisted_33))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.inputControls[inputControlIndex].options, (singleoption, optionIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "optionscontainer border rounded-sm border-lightgrey mt-2.5 p-1.5 text-white flex justify-between bg-darkslategrey min-h-30",
                    key: singleoption
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(singleoption.option), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.onOptionEdit(formIndex, inputControlIndex, optionIndex))
                      }, [
                        _createVNode(_component_PencilIcon, { class: "h-5 w-5" })
                      ], 8, _hoisted_37),
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.onOptionDelete(formIndex, inputControlIndex, optionIndex))
                      }, [
                        _createVNode(_component_TrashIcon, { class: "h-5 w-5" })
                      ], 8, _hoisted_38),
                      (_ctx.hideUpdateIcon)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.onOptionUpdate(formIndex, inputControlIndex, optionIndex))
                          }, [
                            _createVNode(_component_CheckCircleIcon, { class: "w-5 h-5" })
                          ], 8, _hoisted_39))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("button", {
              class: "btnprimary",
              onClick: ($event: any) => (_ctx.save(formIndex, _ctx.inputControlIndex))
            }, "Save", 8, _hoisted_41)
          ])
        ])
      ]))
    }), 128))
  ]))
}